export default __webpack_public_path__ + "static/media/breakfast-overlay@2x.10a62cbf.png";